import { Duration } from "luxon";

export interface EditLocationRequest {
  locationId?: string;
  locationName?: string;
  jobId?: string;
  sequenceNumber:number;
  template?:string;
  stopTime?:Duration;
  serviceTime?:Duration;
  pickupCapacityType1?: number;
  pickupCapacityType2?: number;
  pickupCapacityType3?: number;
  deliveryCapacityType1?: number;
  deliveryCapacityType2?: number;
  deliveryCapacityType3?: number;
  }
